import React, { useEffect } from 'react';
import Tabs, { TabPane } from '@ui-kit/components/tabs';
import { MAIN_ROUTES } from '../../../routing/constants/mainRoutes';
import { useHistory } from 'react-router-dom';
import MainButton from '@ui-kit/components/mainButton';
import { t } from '../../../../utils/helpers';
import { useForm, FormProvider } from 'react-hook-form';
import { PhoneVerification } from '../userVerification/phoneVerification';
import { EmailVerification } from '../userVerification/emailVerification';
import { container } from 'tsyringe';
import { ResponseCode } from '../../../../utils/constants';
import { Loader } from '@ui-kit/components/loader';
import styles from '../../styles/common.module.scss';
import { resetPasswordMessages } from '../../model/const';
import getMessage from '../../utils/getMessage';
import { IModalProvider } from '@base/features/modal/model/interfaces';
import { IAuthService } from '../../model/interfaces';

export const ForgotPassword = () => {
  const authService: IAuthService = container.resolve('authService');
  const modalProvider: IModalProvider = container.resolve('modalProvider');
  const history = useHistory();

  const methods = useForm({
    mode: 'onChange',
    defaultValues: {
      phoneValue: '',
      emailValue: '',
      username: '',
      phoneVerification: {
        token: '',
        regCode: '',
      },
    },
  });
  const {
    getValues,
    formState,
    register,
    trigger,
    handleSubmit,
    formState: { isSubmitting, errors },
  } = methods;

  function goToLogin() {
    history.push(MAIN_ROUTES.login);
  }

  const handleResetPassword = handleSubmit(async (data) => {
    authService
      .resetPassword(data.username, data.phoneValue, data.emailValue)
      .then((res) => {
        if (res.code === ResponseCode.SUCCESS) {
          if (data.emailValue) {
            modalProvider.show({
              title: t('info'),
              body: `Instructions will be sent to ${data.emailValue}`,
              buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
            });
          } else {
            modalProvider.show({
              title: t('info'),
              body: `Instructions will be sent to ${data.phoneValue}`,
              buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
            });
          }
          goToLogin();
        } else {
          showResetPasswordModal(res.code);
        }
      })
      .catch(() => {
        modalProvider.show({
          title: t('info'),
          body: 'unknown_error_try_again',
          buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
        });
      });
  });

  function showResetPasswordModal(code: number): void {
    const re = getMessage(code, resetPasswordMessages);
    modalProvider.show({
      title: t(re.title),
      body: t(re.message),
      buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
    });
  }

  useEffect(() => {
    trigger('username');
  }, []);

  return (
    <>
      {isSubmitting && <Loader className="loader-container--black" />}
      <form className="login-wrap recovery-form-wrap">
        <div className="forgot-password__login">
          <input
            className={
              errors.username && getValues('username').length
                ? 'auth-form-item__text'
                : 'auth-form-item__text auth-form-item__text--valid'
            }
            placeholder={t('username')}
            id={'usernameValue'}
            type="text"
            maxLength={20}
            {...register('username', { required: true, minLength: 3 })}
          />
        </div>
        <FormProvider {...methods}>
          <div className="forgot-password__verification">
            <Tabs>
              <TabPane label="phone" key="1" className={styles.verificationTab}>
                <PhoneVerification mode="request" />
              </TabPane>
              <TabPane label="email" key="2" className={styles.verificationTab}>
                <EmailVerification />
              </TabPane>
            </Tabs>
          </div>
        </FormProvider>
        <div className="register__btn-wrap">
          <MainButton className="register__btn register__btn-cancel" onClick={goToLogin}>
            {t('cancel')}
          </MainButton>
          <MainButton
            className="register__btn register__btn-sign-up"
            disabled={!formState.isValid}
            onClick={handleResetPassword}
          >
            {t('send_request')}
          </MainButton>
        </div>
      </form>
    </>
  );
};
